export default {
    baseStyle: {
        // Search Input
        formFlex: {
            alignItems: 'center',
            mb: 8
        },
        inputGroup: {
            flex: 1
        },
        inputLeftElement: {
            pointerEvents: 'none',
            width: 6,
            left: 1.5
        },
        searchIcon: {
            boxSize: 6
        },
        searchInput: {
            // For some reason textStyle is not working, I needed to add the units
            // base: 16px prevents iOS Safari from auto-zooming on input focus (min threshold is 16px)
            fontSize: {base: 'webLg', lg: 'webMd'},
            fontWeight: 'normal',
            lineHeight: '20px',
            height: 10,
            border: 'none',
            borderBottom: '1px solid',
            borderColor: '#676767',
            borderRadius: 0,
            pl: 9,
            pr: 12,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: '#676767',
            _placeholder: {
                color: '#676767'
            }
        },
        closeButton: {
            variant: 'ghost',
            minWidth: 'none', 
            ml: 2
        },

        // Suggestions Grid
        suggestionsGrid: {
            templateColumns: {base: '1fr', md: 'repeat(4, 1fr)'},
            gap: {base: 4, lg: 6},
            mb: {base: 8, lg: 12}
        },
        suggestionStack: {
            align: 'start',
            spacing: 2
        },
        sectionHeading: {
            // For some reason textStyle is not working, I needed to add the units
            fontSize: {base: 'webMd', lg: 'webSm'},
            color: 'webTypo.textTertiary',
            mb: 1
        },
        overlayBlockTitle: {
            fontSize: {base: 'webMd', lg: 'webMd'},
            lineHeight: {base: '20px', lg: '20px'},
            fontWeight: 'bold',
            textTransform: 'uppercase',
            color: 'webTypo.textPrimary'
        },
        // Recent searches: heading + "Clear All" on one line, each term with its own remove icon
        recentSearchHeader: {
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 1
        },
        recentSearchRow: {
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            minH: {base: '44px', md: 'auto'},
            bg: 'transparent',
            _hover: {
                bg: 'transparent',
                '& a, & [data-testid^="search-suggestion"]': {
                    textDecoration: 'underline'
                }
            }
        },
        recentSearchRemove: {
            variant: 'unstyled',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            minW: {base: '44px', md: 'auto'},
            minH: {base: '44px', md: 'auto'},
            w: 'auto',
            h: 'auto',
            mr: {base: '-14px', md: 0},
            p: 0,
            color: 'webTheme.iconPrimary'
        },
        suggestionItem: {
            // For some reason textStyle is not working, I needed to add the units
            fontSize: 'webMd',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            minHeight: {base: '44px', md: 'auto'},
            _hover: {
                textDecoration: 'underline'
            }
        },
        // Parent category suffix ("in Clothing") — small, regular, secondary per design
        suggestionItemParent: {
            fontWeight: 'normal',
            color: 'webTypo.textSecondary'
        },
        categorySkeleton: {
            height: '21px',
            width: '100%',
            borderRadius: 'md'
        },
        categoryPillsWrap: {
            position: 'relative',
            alignItems: 'center',
            width: '100%',
        },
        categoryPills: {
            flex: '1',
            minWidth: 0,
            gap: '4px',
            overflowX: 'auto',
            overflowY: 'hidden',
            flexWrap: 'nowrap',
            sx: {
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                '&::-webkit-scrollbar': {display: 'none', height: 0, width: 0}
            }
        },
        categoryPillArrow: {
            position: 'absolute',
            zIndex: 2,
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '40px',
            height: {base: '44px', md: '40px'},
            minH: {base: '44px', md: 'auto'},
            padding: 0,
            border: 'none',
            cursor: 'pointer',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            backdropFilter: 'blur(10px)',
            sx: {
                WebkitBackdropFilter: 'blur(10px)',
                transition: 'background-color 0.2s ease',
                '&:hover': {backgroundColor: 'webTheme.backgroundDefault'}
            }
        },
        categoryPill: {
            flexShrink: 0,
            display: 'inline-flex',
            alignItems: 'center',
            bg: 'transparent',
            border: '1px solid',
            borderColor: '#ECE9E9',
            color: '#000000',
            p: '8px',
            fontSize: 'webSm',
            lineHeight: '20px',
            whiteSpace: 'nowrap',
            minH: {base: '44px', md: 'auto'},
            _hover: {
                bg: 'transparent',
                borderColor: 'black'
            }
        },
        categoryPillSkeleton: {
            flexShrink: 0,
            height: {base: '44px', md: '36px'},
            width: '88px',
            borderRadius: '2px'
        },

        // Products Section
        productsHeading: {
            textStyle: 'webH3',
            mb: 4
        },
        mobileSkeletonFlex: {
            gap: 4
        },
        mobileSkeleton: {
            height: '200px',
            width: '48%',
            borderRadius: 'md'
        },
        desktopSkeletonFlex: {
            gap: 2,
            wrap: 'wrap'
        },
        desktopSkeletonBox: {
            width: '163px'
        },
        desktopSkeleton: {
            height: '150px',
            borderRadius: 'md'
        },
        desktopSkeletonText: {
            mt: 2,
            spacing: 2
        },
        swiperWrapper: {
            mx: {base: '-16px', md: 0},
            pb: {base: '32px', md: 0}
        },
        outerWrapper: {
            height: '100vh',
            overflowY: 'auto',
            padding: {base: '0 16px 16px'}
        },

        // Sticky header wrapper (toggle + input)
        stickyHeader: {
            position: 'sticky',
            top: 0,
            zIndex: 2,
            bg: 'white',
            mx: {base: '-16px', lg: '-16px'},
            px: {base: '16px', lg: '16px'}
        },

        // Close button
        closeButtonWrapper: {
            justifyContent: 'flex-end'
        },

        // Mode toggle
        modeToggleWrapper: {
            mb: 8,
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            gap: 0,
            justifyContent: 'center'
        },
        modeToggleButton: {
            textStyle: 'labelXs',
            variant: 'unstyled',
            pb: 2,
            width: '50%',
            textAlign: 'center',
            borderBottom: '1px solid',
            borderColor: 'transparent',
            borderRadius: 0,
            height: 'auto',
            textTransform: 'capitalize',
            cursor: 'pointer'
        },
        modeToggleButtonActive: {
            borderColor: 'webTheme.strokeDefault',
        },

        // Default state suggestions (stacked: recent → trending)
        defaultSuggestionsStack: {
            align: 'start',
            spacing: 8,
            width: '100%',
            mb: {base: 8, lg: 12}
        },

        // Products grid (2-column, replaces swiper)
        productsGrid: {
            gap: 2,
            mb: {base: 8, lg: 12}
        },
        productCardSkeleton: {
            width: '100%',
            borderRadius: 'md'
        },
        productCardSkeletonText: {
            mt: 2,
            spacing: 2
        },

        // No results
        noResultsWrapper: {
            pb: 8,
        },
        noResultsText: {
            textStyle: 'bodyMdRegular',
            color: 'webTypo.textSecondary'
        },

        // Quick View button overlay on product card
        qvOverlay: {
            position: 'absolute',
            bottom: 2,
            right: 2,
            zIndex: 1,
            transition: 'opacity 0.2s',
            opacity: {base: 1, md: 0}
        },

        // Smart search placeholder
        smartSearchPlaceholder: {
            pt: 8
        }
    },
    variants: {
        'storePickupSearch': {
            formFlex: {
                mb: 2
            },
            searchInput: {
                textStyle: 'bodyMdRegular',
                color: 'wenTypo.textPrimary'
            }
        }
    }
}
